import React from 'react';
import PropTypes from 'prop-types';

function PaymentMethodsCard({ paymentMethod, instalmentDetails }) {
  return (
    <>
      <h2 className="text-[22px] mb-2 font-bold">Payment Methods</h2>
      <h2 className="text-md text-[#0F172A] mb-6">Selected Payment Method</h2>
      <div className="w-full mx-auto p-4 md:p-6 rounded-lg border border-[#B8E5FF] shadow-sm bg-[#DBF2FF70] mb-8 ">
        <div className="flex flex-col space-y-2">

          <div className="flex justify-between items-center">

            <div className="flex gap-1 items-baseline">
              <span className="text-[#334155] font-semibold text-[14px] md:text-[18px]">{paymentMethod === 'instalment' ? 'Instalment Plan' : 'Full Payment'}</span>
            </div>

            {instalmentDetails && (
              <div className="flex gap-1 items-baseline">
                <span
                  className="text-[#217ABB] font-semibold text-[14px] md:text-[18px]"
                >
                  {instalmentDetails?.totalInstalments}
                  {' '}
                  instalments
                </span>
              </div>
            )}
          </div>

        </div>
      </div>
    </>
  );
}
PaymentMethodsCard.propTypes = {
  paymentMethod: PropTypes.string.isRequired,
  instalmentDetails: PropTypes.object.isRequired,
};
export default PaymentMethodsCard;
